// GENERATED CODE - DO NOT EDIT
export const StatusTypeMap = {
    INACTIVE: 'inactive',
    ACTIVE: 'active',
    COMPLETED: 'completed',
};
//# sourceMappingURL=prescription_timeline_status.js.map